import { render, staticRenderFns } from "./core.vue?vue&type=template&id=9da9cdb8&scoped=true"
import script from "./core.vue?vue&type=script&setup=true&lang=js"
export * from "./core.vue?vue&type=script&setup=true&lang=js"
import style0 from "./core.vue?vue&type=style&index=0&id=9da9cdb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da9cdb8",
  null
  
)

export default component.exports